import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';

type B3ModalElement = HTMLElement & { open?: boolean };

@Component({
  standalone: false,
  selector: 'app-project-validation-approve-modal',
  templateUrl: './project-validation-approve-modal.component.html',
  styleUrls: ['./project-validation-approve-modal.component.scss'],
})
export class ProjectValidationApproveModalComponent {
  @ViewChild('approveModal') approveModal?: ElementRef<B3ModalElement>;

  @Input() open = false;
  @Input() heading = 'Confirmação';
  @Input() message = 'Deseja aprovar este projeto?';

  @Output() closed = new EventEmitter<boolean>();

  onCancel(): void {
    this.closeModal(false);
  }

  onConfirm(): void {
    this.closeModal(true);
  }

  onModalDismiss(): void {
    this.closeModal(false);
  }

  private closeModal(confirmed: boolean): void {
    const modalHost = this.approveModal?.nativeElement;
    if (modalHost) {
      modalHost.open = false;
    }

    document.querySelectorAll('dialog[open]').forEach(element => {
      if (element instanceof HTMLDialogElement) {
        element.close();
      }
    });

    this.closed.emit(confirmed);
  }
}
